import { AccessRolePayload, AccessRole } from "models/accessRole";
import axiosClient from "./axiosClient";
import { ApiResponse, RemovePayload } from "models";

const adminUserMgmtAccessRoleApi = {
  getAccessRoleList(data: AccessRolePayload): Promise<AccessRole> {
    const url = `/accessRoleModuleManage/getAllAccessRole?limit=${
      data.limit || ""
    }&page=${data.page || ""}&search=${data.search || ""}&sortField=${
      data.sortName || ""
    }&sortType=${data.sortType || ""}`;
    return axiosClient.get(url);
  },

  getAccessRolebyId(id: any): Promise<AccessRole> {
    const url = `/accessRoleModuleManage/getAccessRoleById?id=${id}`;
    return axiosClient.get(url);
  },

  getModuleList(): Promise<AccessRole> {
    const url = `/roleModuleManage/getAllRoleModule`;
    return axiosClient.get(url);
  },

  getAllPermissions(): Promise<any> {
    const url = `/permission/getAllPermissions?disablePagination=true`;
    return axiosClient.get(url);
  },

  getModuleById(id: any): Promise<AccessRole> {
    const url = `/roleModuleManage/getRoleModuleById?id=${id}`;
    return axiosClient.get(url);
  },

  addAccessRole(data: AccessRole): Promise<ApiResponse> {
    const url = `/accessRoleModuleManage/addAccessRoleModule`;
    return axiosClient.post(url, data);
  },
  updateAccessRole(data: AccessRole): Promise<ApiResponse> {
    const url = `/accessRoleModuleManage/updateAccessRole`;
    return axiosClient.put(url, data);
  },

  deleteAccessRole(data: RemovePayload): Promise<ApiResponse> {
    const url = `/accessRoleModuleManage/removeAccessRole?id=${data._id}`;
    return axiosClient.post(url);
  },
};

export default adminUserMgmtAccessRoleApi;
